import { useState, useEffect } from "react";
import { getTableData } from "../../helpers/process_morningstar.js";
import {
  Box,
  Container,
  Typography,
  Table,
  TableBody,
  TableHead,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  CircularProgress,
} from "@mui/material";


export default function MorningStar() {
  const [tables, setTables] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchAllData() {
      const tableNames = [
        "Asset Class",
        "Balance Sheet 12M",
        "Balance Sheet 3M",
        "Balance Sheet 6M",
        "Balance Sheet 9M",
        "Cash Flow 12M",
        "Cash Flow 3M",
        "Cash Flow 6M",
        "Cash Flow 9M",
        "Company",
        "Company Long Description",
        "Earnings Reports 12M",
        "Earnings Reports 3M",
        "Earnings Reports 6M",
        "Earnings Reports 9M",
        "General Profile",
        "Income Statement 12M",
        "Income Statement 3M",
        "Income Statement 6M",
        "Income Statement 9M",
        "PVLongTerm",
        "PVTwoYears",
        "Parameters",
        "QuarterlyPrice",
        "Rates",
        "Security",
      ];

      const results = {};
      for (const name of tableNames) {
        try {
          const data = await getTableData(name);
          results[name] = data;
        } catch (err) {
          console.error(`Failed to fetch ${name}:`, err);
          results[name] = null;
        }
      }

      setTables(results);
      setLoading(false);
    }

    fetchAllData();
  }, []);

  if (loading) {
    return (
      <Container sx={{ textAlign: "center", mt: 4 }}>
        <CircularProgress />
        <Typography mt={2}>Loading MorningStar Data...</Typography>
      </Container>
    );
  }

console.log(tables);

  return (
    <Box sx={{ mt: 4, mb: 8, mx: '25px' }}>

      {Object.entries(tables).map(([name, data]) => (
        <Box key={name} sx={{ mx: "25px", my: 2 }} >
          <Typography variant="h6" gutterBottom>
            {name}
          </Typography>

          {Array.isArray(data) && data.length > 0 ? (
            <TableContainer component={Paper} sx={{ 
              overflowX: 'auto', 
              boxShadow: "none",
              borderRadius: 2, 
              width: name === "Asset Class" || "Parameters" ? 'fit-content' : '100%',              
              maxWidth: '100%',
              }}
            >
              <Table size="small" >
                <TableHead>
                  <TableRow>
                    {Object.keys(data[0]).map((col) => (
                      <TableCell key={col} sx={{ 
                        fontWeight: "bold", 
                        fontSize: 10,
                        backgroundColor: "#324052", 
                        borderRight: "1px solid #bbbbbbff",
                        color: "white",
                        padding: 1,
                        textAlign: 'center',
                        whiteSpace: 'nowrap' 
                        }}
                      >
                        {col}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.map((row, i) => (
                    <TableRow key={i}>
                      {Object.keys(data[0]).map((col) => (
                    <TableCell key={col} sx={{ 
                      fontSize: 10,
                      borderRight: "1px solid #bbbbbbff", 
                      padding: 1, 
                      whiteSpace: 'nowrap', 
                      textAlign: 'right',
                      backgroundColor: i % 2 === 0 ? "#f9f9f9" : "white",
                      }}
                    >
                          {String(row[col] ?? "")}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : data && typeof data === "object" ? (
            <TableContainer component={Paper}>
              <Table size="small">
                <TableBody>
                  {Object.entries(data).map(([key, value]) => (
                    <TableRow key={key}>
                      <TableCell sx={{ fontWeight: "bold",  }}>{key}</TableCell>
                      <TableCell>{String(value ?? "")}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Typography variant="body2" color="text.secondary">
              No data available
            </Typography>
          )}
        </Box>
      ))}
    </Box>
  );
}
